import { useRef, useState } from "react";

interface Filedragdrop {
  uuid: string;
  file: File;
}
const Usedragdrop = () => {
  const refInput = useRef<HTMLInputElement>(null);
  const refContainer = useRef<HTMLDivElement>(null);
  const [files, setFiles] = useState<Array<Filedragdrop>>([]);
  const [dragStatus, setDragStatus] = useState<boolean>(false);
  const [errorFile, setErrorFile] = useState<string | null>(null);
  const addFile = (file: File | undefined, num: number) => {
    if (file !== undefined) {
      if (fileValidate(file)) {
        if (files.length < num) {
          const uuid = new Date().getTime().toString();
          setFiles((files) => [...files, { uuid, file }]);
        } else {
          setErrorFile("Max files upload");
          setTimeout(() => {
            setErrorFile(null);
          }, 3000);
        }
      }
    }
  };

  const onClickDrag = () => {
    refInput.current?.click();
  };

  const onDrop = (e: React.DragEvent<HTMLDivElement>, num: number) => {
    e.preventDefault();
    const file_target = e.dataTransfer?.files;
    addFile(file_target?.[0], num);
    setDragStatus(false);
  };

  const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (!dragStatus) {
      setDragStatus(true);
    }
  };

  const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragStatus(false);
  };

  const onChangefile = (
    data: React.ChangeEvent<HTMLInputElement>,
    num: number
  ) => {
    const file_target = data.target.files?.[0];
    addFile(file_target, num);
    data.target.value = "";
  };
  const onDelete = (uuid_delete: string) => {
    const files_delete = files.filter(({ uuid }) => uuid !== uuid_delete);
    setFiles(files_delete);
  };

  const fileValidate = (file: File) => {
    const typeFile = file.type;
    const validExtension = refInput.current?.accept.split(",");
    try {
      if (validExtension?.includes(typeFile)) {
        return true;
      } else {
        setErrorFile("Incompatible file");
        setTimeout(() => {
          setErrorFile(null);
        }, 3000);
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    refInput,
    onChangefile,
    refContainer,
    dragStatus,
    files,
    onDelete,
    errorFile,
    onClickDrag,
    onDrop,
    onDragOver,
    onDragLeave,
  };
};
export default Usedragdrop;
